import { render, staticRenderFns } from "./PermanentNhIndex.vue?vue&type=template&id=06da6f65"
import script from "./PermanentNhIndex.vue?vue&type=script&lang=js"
export * from "./PermanentNhIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports